<div class="itsl-course-info-box itsl-course-info-box__read-view">
    <CourseInfoBoxImage />
    <CourseInfoBoxContent />
    <slot name="custom" />
</div>

<script>
    import CourseInfoBoxContent from "./CourseInfoBoxContent.svelte";
    import CourseInfoBoxImage from "./CourseInfoBoxImage.svelte";
</script>
